/**
 * @Description 新增打靶任务 form表单
 */
import { FC, useEffect, useRef, useState } from 'react';
import styles from './index.module.less';
import cs from 'classnames';
import V2Form from '@/common/components/Form/V2Form';
import { Button, Form } from 'antd';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { checkInFieldAFormContainer } from '../ts-config';
import V2FormTextArea from '@/common/components/Form/V2FormTextArea/V2FormTextArea';
import { postCheckInCreateTask } from '@/common/api/youth';
import { useBigdataFn } from '@/common/utils/bigdata';

const AddForm:FC<any> = ({
  marker,
  addressInfo,
  onClose,
  _mapIns,
  targetPunchInAlias = '打靶'
}) => {
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [form] = Form.useForm();
  const isLockRef = useRef<boolean>(false);
  const [lock, setLock] = useState<boolean>(false);

  const handleCancel = () => {
    marker && marker.current.setContent(` `);
    onClose();
  };

  // 创建请求
  const handleCreate = async() => {
    form.validateFields()
      .then((values) => {
        if (isLockRef.current) return;
        bigdataFn('3add10af-dd73-4a13-adbd-734ce23fb590', '新增打靶任务-确定', '新增了打靶任务', { op_block: '工具箱', op_event: ``, });
        isLockRef.current = true;
        setLock(true);
        submitData(values);
      })
      .catch(() => {
        V2Message.warning('请输入所有必填项');
      });
  };

  /**
   * @description 不需要审批时，提交开店区域
   * @param values 表单数据
   */
  const submitData = (values) => {
    const params = {
      ...values,
      ...addressInfo,
    };
    postCheckInCreateTask(params).then(() => {
      V2Message.info(`发布成功`);
      marker && marker.current.setContent(` `);
      onClose(true);
    }).finally(() => {
      isLockRef.current = false;
      setLock(false);
    });
  };

  // 处理滚动事件
  const handlePreventdefault = (e: any) => {
    e.stopPropagation();
  };

  useEffect(() => {
    const { provinceName, cityName, districtName } = addressInfo;
    form.setFieldValue('address', `${provinceName || '-'}/${cityName || provinceName || '-'}/${districtName || '-'}`);

    const dom:any = document.querySelector(`.${checkInFieldAFormContainer}`);
    dom.addEventListener('mousewheel', handlePreventdefault);
    dom.addEventListener('wheel', handlePreventdefault);
    return () => {
      dom.removeEventListener('mousewheel', handlePreventdefault);
      dom.removeEventListener('wheel', handlePreventdefault);
    };
  }, []);
  // 地图是否可拖拽
  const handleDragEnable = (dragEnable: boolean) => {
    _mapIns && _mapIns.setStatus({
      dragEnable
    });
  };

  return <div
    className={cs(styles.checkInFieldAFormContainer, checkInFieldAFormContainer)}
    onMouseDown={() => handleDragEnable(false)}
    onMouseUp={() => handleDragEnable(true)}
    onMouseMove={() => handleDragEnable(false)}
    onMouseLeave={() => handleDragEnable(true)}
  >
    <div className={styles.title}>新增{targetPunchInAlias}任务</div>
    <V2Form form={form} className={styles.from} preserve={false} >
      <V2FormInput
        label='所在城区'
        name='address'
        required
        disabled={true}
      />
      <V2FormTextArea
        label={`打卡要求`}
        name='requirement'
        maxLength={300}
        config={{
          onKeyDown: (e: any) => {
            // 禁止输入框内键盘缩放地图
            e.stopPropagation();
          },
        }}
      />
    </V2Form>
    <div className={styles.bottom}>
      <Button onClick={() => handleCancel()}>取消</Button>
      <Button
        loading={lock}
        type='primary'
        className='ml-12'
        onClick={() => handleCreate()}
      >确定</Button>
    </div>
  </div>;
};
export default AddForm;
